import { useDispatch } from 'react-redux';
import {
  createAccountType,
  patchAccountType,
} from '../store/actions/application/applicationActions';
import useApplicationUid from './useApplicationUid';

const useBusinessTypeDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const businessTypeDispatch = ({ data, shouldUpdate, onSuccess }) => {
    const requestData = {
      ApplicationUid,
      data,
      onSuccess,
    };

    if (shouldUpdate) {
      dispatch(
        patchAccountType({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createAccountType({
        ...requestData,
      }),
    );
  };

  return { businessTypeDispatch };
};

export default useBusinessTypeDispatch;
